import HTMLReactParser from "html-react-parser";
import React from "react";
import { SlotType } from "../../../lib/types";

interface IProps {
  slotPrices: Array<{ gold: number; bricks: number }>;
  building: SlotType
}

const BuildingDetail = ({ building }: IProps) => (
  <span>
    <h3 className="name">
      {building.name}
    </h3>
    <p>
      {HTMLReactParser(building.descriptionLong)}
    </p>
    {/* <p> */}
    {/*  <span className="white"> */}
    {/*    <em>{slotPrices[building.id].gold}</em>&nbsp; */}
    {/*    <i className={"icon icon-xs icon-zlato gold middle"}/> */}
    {/*    + <em>{slotPrices[building.id].bricks}</em>&nbsp; */}
    {/*    <i className={"icon icon-xs icon-infrastrukturni-body middle"}/> */}
    {/*  </span><br/> */}
    {/*  {building.turns} turns */}
    {/* </p> */}
    {/* {building.prerequisities && <p> */}
    {/*  Requires:<br/> */}
    {/*  {building.prerequisities} */}
    {/* </p>} */}
  </span>
)

export default BuildingDetail;
